<template>
  <div class="calendar_comm">
    <div class="head_calendar">
      <strong class="date_chart">{{ calendarData.targetMonth | convertDateFormat('YYYY년 M월') }}</strong>
      <div class="area_control">
        <button
          v-if="isShowTodayMonthBtn"
          class="btn_control btn_today"
          @click="onClickTodayMonth()">
          Today
        </button>
        <button
          class="btn_control btn_prev"
          :disabled="isDisabledPrevMonthBtn"
          @click="onClickPrevMonth()">
          <IconSvg
            iconName="arrow_left"
            :size="12"
            :iconColor="isDisabledPrevMonthBtn ? 'DISABLED_ICON' : 'DEFAULT_ICON'"
            :iconDarkColor="isDisabledPrevMonthBtn ? 'DISABLED_ICON_DARK' : 'DEFAULT_ICON_DARK'"/>
        </button>
        <button
          class="btn_control btn_next"
          :disabled="isDisabledNextMonthBtn"
          @click="onClickNextMonth()">
          <IconSvg
            iconName="arrow_right"
            :size="12"
            :iconColor="isDisabledNextMonthBtn ? 'DISABLED_ICON' : 'DEFAULT_ICON'"
            :iconDarkColor="isDisabledNextMonthBtn ? 'DISABLED_ICON_DARK' : 'DEFAULT_ICON_DARK'"/>
        </button>
      </div>
    </div>
    <div class="body_calendar">
      <p v-if="hasInfoNotes" class="info_notes">
        <slot name="infoNotes"/>
      </p>
      <div class="list_week">
        <div
          :class="['item_week', { weekend : week === '토' || week === '일' }]"
          v-for="week in weekKoreanDataList"
          :key="week">{{ week }}</div>
      </div>
      <div class="list_day"
        @mouseenter="onMouseEnter()"
        @mouseover="onMouseEnter()"
        @mouseleave="onMouseLeave()">
        <DatePickerCalendarDayItem
          v-for="(dayItemData, index) in monthDrawDataList"
          :key="`calendar_item${index}`"
          :index="index"
          :dayItemData="dayItemData"
          :value="value"
          :isRange="calendarData.isRange"
          :focuseDate="focuseDate"
          @onFocuseDate="onFocuseDate(dayItemData.fullDate)"
          @onClickDay="$emit('onClickDay',dayItemData.fullDate)">
          <!-- :isSelect="isSelect(dayItemData.fullDate)"
          :isSelectStart="isSelectRange(dayItemData.fullDate).start"
          :isSelectInRange="isSelectRange(dayItemData.fullDate).inRange"
          :isSelectEnd="isSelectRange(dayItemData.fullDate).end" -->
          <template v-slot:calendarDayBody="slotProps">
            <slot name="calendarDayBody" :dayItemData="slotProps.dayItemData"/>
          </template>
        </DatePickerCalendarDayItem>
      </div>
    </div>
  </div>
</template>

<script>
import IconSvg from '@lemontree-ai/lemontree-admin-common-front/components/common/icon/IconSvg';
import DatePickerCalendarDayItem from '@lemontree-ai/lemontree-admin-common-front/components/common/calendar/DatePickerCalendarDayItem'
import CalendarMixin from '@/adminPackage/mixins/CalendarMixin';

export default {
  name: 'DatePickerCalendar',
  mixins: [CalendarMixin],
  components:{
    IconSvg,
    DatePickerCalendarDayItem
  },
  props:{
    value: [String, Array],
    calendarData:{
      targetMonth: String, // YYYY-MM
      searchDataRangeMonthly: {
        start_date: String, // YYYY-MM-DD
        end_date: String // YYYY-MM-DD
      },
      limitMinMonth: String, // YYYY-MM-DD
      calendarEvent: Array,
      isSchedule: {
        type: Boolean,
        default: false
      },
      isRange: {
        type: Boolean,
        default: false
      },
    },
    dataList:[],
  },
  data(){
    return {
      focuseDate: '',
      isHover: false
    }
  },
  mounted(){
    // if(!this.calendarData.targetMonth){
    //   this.calendarData.targetMonth = convertDateFormat(new Date(), 'YYYY-MM');
    // }
    this.setMonthSearchDate();
    // this.setMonthData();
    this.$emit('getMonthData');
  },
  // mounted(){
  // },
  computed:{
    hasInfoNotes(){
      return this.$slots['infoNotes']
    },
  },
  watch:{
    'calendarData.targetMonth':{
      deep:true,
      handler(newVal, oldVal) {
        if(newVal != oldVal){
          this.setMonthSearchDate();
        }
        // this.setMonthSearchDate();
        // this.setMonthData();
      },
    },
    isHover(){
      if(!this.isHover){
        this.focuseDate = '';
      }
    },
  },
  methods:{
    isHasDateData(dayItemData){
      const { isPrevMonthDay, isNextMonthDay } = dayItemData;
      return !isPrevMonthDay && !isNextMonthDay;
    },
    dateData(dayItemData){
      const { fullDate } = dayItemData;
      let result = {}
      const data = this.dataList.find(item => item.date === fullDate);
      if(data){
        result = data;
      }
      return result;
    },
    onMouseEnter(){
      this.isHover = true;
    },
    onMouseLeave(){
      this.isHover = false;
    },
    onFocuseDate(focuseDate){
      this.focuseDate = focuseDate;
    },
  }
}
</script>

<style lang="scss" scoped>
.head_calendar{text-align:center}
.head_calendar:after{display:block;visibility:hidden;height:0;font-size:0;clear:both;content:''}
.date_chart{float:left;font-weight:500;font-size:16px;line-height:30px;vertical-align:top}
.area_control{float:right}
.btn_control{padding:8px;border-radius:$CONTENT_RADIUS;border:1px solid $DEFAULT_BORDER;font-weight:700;line-height:12px;}
.btn_control.btn_prev{margin-left:10px}
.btn_control.btn_next{margin-left:10px}
.btn_control.btn_today{padding:8px 14px}
.btn_control:disabled{background-color:$DISABLED_BG}
.btn_control.btn_today:disabled{color:$DISABLED_TEXT;background-color:$DISABLED_BG}
.body_calendar{margin-top:28px}

.list_week,
.list_day{display:flex;flex-wrap:wrap;width:100%}
.list_week{border-bottom:1px solid $DEFAULT_BORDER}
.item_week{display:inline-block;flex:1 1 14.2%;width:14.2%;padding-bottom:10px;font-size:14px;line-height:18px;font-weight:500;vertical-align:top;box-sizing:border-box;text-align:center}
.item_week.weekend{color:#888}

.list_day{margin-top:6px}


@media (prefers-color-scheme: dark) {
  .btn_control{border-color:$DEFAULT_BORDER_DARK}
  .btn_control:disabled{border-color:$DEFAULT_BORDER_DARK;background-color:$DISABLED_BG_DARK}
  .btn_control.btn_today:disabled{color:$DISABLED_TEXT_DARK;background-color:$DISABLED_BG_DARK}

  .list_week{border-bottom-color:$DEFAULT_BORDER_DARK}
}
</style>